/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
// import posthog from 'posthog-js'

// posthog.init('phc_uvyccVCnLMEerxU4SNkAVTqQ4fbsBvijT3hgIoDtzRl',
//   {
//       api_host: 'https://us.i.posthog.com',
//       // person_profiles: 'identified_only' // or 'always's to create profiles for anonymous users as well
//   }
// )

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
